import React, {useContext, useEffect, useState} from 'react'
import cn from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import LeaderboardTableLayout from '../../../../components/EngageComponents/LederboardComponent/LeaderboardTableComponent'
import { useDispatch, useSelector } from 'react-redux';
import Form from '../../../../components/Form';
import Icon from "../../../../components/Icon";
import Card from "../../../../components/Card";
import addIcon from '../../../../media/images/icons/light.png'
import styles from './getMatches.module.sass'
import EmptyStates from '../../../../components/EmptyStates';
import Loader from '../../../../components/Loaders/LoaderProgress';
import { getAllMatchesAction } from '../../../../redux/action/builds/matches/matchesAction';
import { filterLeaderboardAction, getAllLeadboardAction } from '../../../../redux/action/engage/Leaderboard/leaderboardAction';
import {ReactComponent as Previous} from '../../../../media/images/icons/previous.svg'
import {ReactComponent as Next} from '../../../../media/images/icons/next.svg'
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import {ReactComponent as ArchiveSvg} from '../../../../media/images/icons/archive.svg'
import { Skeleton } from '@mui/material';
import SkeletonTable from '../../../../components/Skeleton/TableSkeleton';
import SkeletonEmptyState from '../../../../components/Skeleton/EmptyStateSkeleton';
import GlobalStateContext from '../../../../components/Context/GlobalStates/GlobalStateContext';
import { ToastContainer } from 'react-toastify';
import Calendar from "../../LiveOps/Calendar";
import Control from './Filters/Control'
import moment from 'moment';
import Navigation from '../../../../components/Header/SecondaryNavigation';

const sorting = ["list", "grid"];

const GetLeaderboard = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {appid} = useParams()
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeViewIndex, setActiveViewIndex] = React.useState(0);
    const modes = [{value:"list",icon:"list"}, {value:"calendar",icon:"calendar"}];
    // Pagination
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    // Search
    const [search, setSearch] = useState(null)
    // Filters
    const [source, setSource] = useState([])
    const [leaderboardRanking, setLeaderboardRanking] = useState([])
    const [isRecurring, setIsRecurring] = useState(null)
    const [isPrizeConfigured, setIsPrizeConfigured] = useState(null)
    const [schduleType, setSchduleType] = useState([])
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [recurrance, setRecurrance] = useState(null)
    const [recurranceInterval, setRecurranceInterval] = useState(null)
    const [recurranceIntervalId, setRecurranceIntervalId] = useState(null)
    const [status, setStatus] = useState([])
    const [instanceStatus, setInstanceStatus] = useState([])
    const filters = {source, setSource, leaderboardRanking, setLeaderboardRanking, isRecurring, setIsRecurring, isPrizeConfigured, setIsPrizeConfigured, schduleType, setSchduleType, startDate, setStartDate, endDate, setEndDate, recurranceInterval, setRecurranceInterval, recurrance, setRecurrance, recurranceIntervalId, setRecurranceIntervalId, status, setStatus, instanceStatus, setInstanceStatus}
    // Sort
    const sortList = [{id: 1, name: 'Leaderboard Name', value: 'name'}, {id: 2, name: 'Created At', value: 'created_at'}, {id: 3, name: 'Updated At', value: 'updated_at'}]
    const [sortValue, setSortValue] = useState({name: 'updated_at', value: 0})
    const [selectedSort, setSelectedSort] = useState('updated_at')
    const [sort, setSort] = useState([{id: 1, name: 'Ascending'}, {id : 2, name : 'Descending'}])
    const [sortIndex, setSortIndex] = useState(0)
    // User Access
    const [userAccess, setUserAccess] = useState(false)
    const globalStates = useContext(GlobalStateContext)
  
    const getUserAccess = () => {
      if(globalStates && globalStates.user && globalStates.user.memberAccessConfig?.length > 0){
        let appPermission = globalStates.user.memberAccessConfig.filter((obj) => (obj.projectId === appid))
        if(appPermission?.length > 0){
          setUserAccess(appPermission[0].permissions.id === 1 ? true : false)
        }
      }
    }
    
    useEffect(() => {
      getUserAccess()
    }, [])

    const getAllLeaderboard = async(search) => {
      let leaderboard = {
        projectId : appid,
        // Search
        ...(search && search !== null && search !== '' && {search : search}),
        //Filters
        ...(source?.length > 0 && {sourceTypeId: source}),
        ...(leaderboardRanking?.length > 0 && {leaderboardOutcomeTypeMasterId: leaderboardRanking}),
        ...(isRecurring  != null && {isRecurring : isRecurring}),
        ...(isPrizeConfigured  != null && {isPrizeConfigured: isPrizeConfigured}),
        ...(schduleType?.length > 0 && {scheduleType: schduleType}),
        ...((recurrance !== null && recurrance !== '') && {recurrenceFrequency: recurrance}),
        ...((recurranceIntervalId !== null && recurrance !== '') && {intervalUnitId: recurranceIntervalId}),
        ...(startDate !== '' && {startDate : (moment(startDate).format('YYYY-MM-DD')).concat(' 00:00:00+00:00')}),
        ...(endDate !== '' && {endDate : (moment(endDate).format('YYYY-MM-DD')).concat(' 00:00:00+00:00')}),
        ...(status?.length > 0 && {status : status}),
        ...(instanceStatus?.length > 0 && {instanceStatus : instanceStatus}),
        // Sort
        sortOrder : (sortIndex == 0 ? 'asc' : 'desc'),
        sortField : selectedSort,
        offset: ((page-1)*limit),
        limit: limit
      }
      let keysToCheck = ['source', 'leaderboardRanking', 'schduleType', 'status', 'instanceStatus']
      let isFiltered = await keysToCheck.every(key => filters[key]?.length === 0)
      let isChecked = await (filters.hasOwnProperty('isRecurring') && filters.isRecurring === null && filters.isRecurring !== '') && (filters.hasOwnProperty('isPrizeConfigured') && filters.isPrizeConfigured === null && filters.isPrizeConfigured !== '') && (filters.hasOwnProperty('startDate') && filters.startDate === '') && (filters.hasOwnProperty('endDate') && filters.endDate === '') && (filters.hasOwnProperty('recurrance') && filters.recurrance === null) && (filters.hasOwnProperty('recurranceIntervalId') && filters.recurranceIntervalId === null) 
      if(!search && isFiltered && isChecked){
        console.log('one')
        await dispatch(getAllLeadboardAction(leaderboard, configureSkeleton))
      }else{
        console.log('two')
        await dispatch(filterLeaderboardAction(leaderboard, configureSkeleton, (!isFiltered || !isChecked)))
      }
    }

    let leaderboard = useSelector((state) => {
      return state.leaderBoards.leaderBoard
    })

    let isLoading = useSelector((state) => {
      return state.leaderBoards.isLoading
    })

    let totalLeaderboard = useSelector((state) => {
      return state.leaderBoards.totalCount
    })

    let isFiltered = useSelector((state) => {
      return state.leaderBoards.isFiltered
    })

    const [showSkeleton, setShowSkeleton] = useState(true)

    const configureSkeleton = () => {
      setShowSkeleton(true)
      setTimeout(() => {
        setShowSkeleton(false)
      }, 1000)
    }

    useEffect(() => {
      if(selectedSort !== null){
        getAllLeaderboard(search)
      }
    }, [page, selectedSort])

    const handlePageChange = (event, value)  => {
      setPage(value)
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const onSearch = (search) => {
      if(search === ''){
        setSearch(null)
        getAllLeaderboard()
      }else{
        setSearch(search)
        getAllLeaderboard(search)
      }
    }

    // Loader
    if(isLoading){
      return(
        <>
          <div className={styles.loader}>
            <Loader />
          </div>
        </>
      )
    }

    return(
      <>
        <ToastContainer />
        <Navigation type='Leaderboard' modes={modes} view={activeViewIndex} setView={setActiveViewIndex} filterAction={getAllLeaderboard} filters={filters} search={search} setSearch={onSearch} data={sortList} setPage={setPage} sortIndex={sortIndex} setSortIndex={setSortIndex} selected={selectedSort} setSelected={setSelectedSort} sort={sort} setSort={setSort} value={sortValue} setValue={setSortValue} />
        <Card layOut={`Get`} className={styles.card} classCardHead={styles.head}>
          {activeViewIndex === 0 && 
            <div className={styles.wrapper}>
              {/* Leaderboards Table View */}
              {showSkeleton && leaderboard?.length === 0 && 
                <SkeletonEmptyState />
              }
              {showSkeleton && leaderboard?.length > 0 && 
                <SkeletonTable from={2} usedFor='Engage' rows={leaderboard.length} column={7} controls={1}  type={['recatangle', 'recatangle', 'recatangle', 'reactangle', 'reactangle', 'reactangle', 'circular']} colWidth={[36, 100, 100, 100, 100, 100, 36]} colHeight={[36, 15, 16, 16, 16, 16, 36]} />
              }
              {!showSkeleton && !isFiltered && leaderboard?.length === 0 &&
                <EmptyStates access={userAccess} route={`/create-leaderboard/${appid}`} type="Leaderboard" />
              }
              {!showSkeleton && !isFiltered &&leaderboard?.length > 0 &&
                <LeaderboardTableLayout access={userAccess} items={leaderboard} title="Last edited" /> 
              }
              {!showSkeleton && isFiltered &&
                (leaderboard?.length > 0 ?
                  <LeaderboardTableLayout access={userAccess} items={leaderboard} title="Last edited" /> 
                :
                  <div className={styles.message}>No Result Found</div>
                )
              }

              {!isLoading && leaderboard.length > 0 &&
                <div className={styles.pagination}>
                  <Stack spacing={2}>
                    <Pagination page={page} renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        sx={{
                          '&.MuiPaginationItem-root': {
                            minWidth: '28px',
                            height: '28px',
                            fontSize: '12px'
                          },
                          '&.Mui-selected': {
                            color: 'rgb(255, 255, 255)',
                            fontWeight : 'bold',
                            border : '1px solid rgb(42, 133, 255)',
                            background : 'rgba(42, 133, 255)'
                          },
                          '&.MuiPaginationItem-page.Mui-selected:hover' : {
                            color: 'rgb(255, 255, 255)',
                            fontWeight : 'bold',
                            border : '1px solid rgb(42, 133, 255)',
                            background : 'rgba(42, 133, 255)'
                          }
                        }}
                      />
                    )} siblingCount={1} count={Math.ceil(totalLeaderboard/limit)} color="primary" onChange={handlePageChange} />
                  </Stack>
                </div>
              }
            </div>
          }
          {activeViewIndex === 1 && <div><Calendar/></div>}
        </Card>
        <div className="divider"></div>
        <div className={styles.msg}>
          <p className={styles.alert}>Learn more about Leaderboards <a className={styles.infoLink} href="https://manual.specterapp.xyz/specter-user-manual/engage/leaderboards" target="_blank">Click Here</a></p>
        </div>
      </>
    )
    
}

export default GetLeaderboard